import { Badge } from '@/components/ui/badge';
import { CheckCircle, AlertTriangle, XCircle } from 'lucide-react';

interface HealthCheckBadgeProps {
  score: number;
  onClick?: () => void;
}

export const HealthCheckBadge = ({ score, onClick }: HealthCheckBadgeProps) => {
  const getColor = () => {
    if (score >= 90) return 'bg-green-500 hover:bg-green-600';
    if (score >= 70) return 'bg-amber-500 hover:bg-amber-600';
    return 'bg-destructive hover:bg-destructive/90';
  };

  const getIcon = () => {
    if (score >= 90) return <CheckCircle className="h-3.5 w-3.5" />;
    if (score >= 70) return <AlertTriangle className="h-3.5 w-3.5" />;
    return <XCircle className="h-3.5 w-3.5" />;
  };

  const getLabel = () => {
    if (score >= 90) return 'Excellent';
    if (score >= 70) return 'Good';
    if (score >= 50) return 'Fair';
    return 'Needs Attention';
  };

  return (
    <Badge 
      className={`${getColor()} text-white px-3 py-1.5 text-sm font-medium cursor-pointer transition-colors`}
      onClick={onClick}
    >
      <span className="flex items-center gap-2">
        {getIcon()}
        <span>Health: {score}/100</span>
        <span className="opacity-80">({getLabel()})</span>
      </span>
    </Badge>
  );
};
